<div>
  @for (taxSummary of taxSummaryDetails(); track $index) {
    <div class="mb-4">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <h3 class="mb-0">{{ taxSummary.taxSummaryType.name }}</h3>
        <div class="review-date-display">
          <span class="review-date-display-label">
            {{ 'shared.lastReviewDate' | translate }}
          </span>
          <span class="review-date-display-value">
            {{
              taxSummary.reviewDate
                ? (taxSummary.reviewDate | date: 'dd MMMM yyyy')
                : '-'
            }}
          </span>
        </div>
      </div>
      <div class="d-flex">
        <div class="flex-grow-1">
          <div class="p-4 bg-white border rounded flex-grow-1">
            @if (!isForceEditorToRenderAgain()) {
              <div class="ap-pr-spacing-3">
                <gstar-editor
                  [mode]="editorReadOnlyMode"
                  [content]="
                    taxSummary.description | blankLinks | safe: 'html'
                  " />
              </div>
            }
          </div>
        </div>
        <div *gstarCanEditCountry="taxSummary.countryId">
          <gstar-action-menu [actionMenu]="actionMenu" [rowData]="taxSummary" />
        </div>
      </div>
    </div>
  } @empty {
    <div class="p-4 bg-white border rounded flex-grow-1">
      <div class="overflow-auto ap-pr-spacing-3 tax-rates-summary-box">
        {{ notFoundMessage() }}
      </div>
    </div>
  }
</div>
